import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SanitizerPipe } from 'src/app/shared/pipes';
import { PaymentMethodItemService } from '../services/payment-methods.service';

@Component({
    selector: 'app-credit-amount',
    standalone: true,
    imports: [CommonModule, SanitizerPipe],
    templateUrl: './credit-amount.component.html',
    styleUrls: ['./credit-amount.component.scss'],
})
export class CreditAmountComponent implements OnInit, OnDestroy {
    @Input() creditAmount: number;
    @Input() externalMessage = false;

    public showMessage = false;
    private unsubscribe$: Subject<void>;

    constructor(private paymentMethodItemService: PaymentMethodItemService) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.isEnoughtCredit();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    isEnoughtCredit(): void {
        this.paymentMethodItemService
            .isEnoughCredit(this.creditAmount)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((isEnoughtCredit: boolean) => {
                if (!isEnoughtCredit) {
                    this.showMessage = true;
                }
            });
    }
}
